<template>
  <v-container class="page-content">
    <v-row>
      <v-col cols="12">
        <h1>Customize the GHG Calculator</h1>
        <p class="mb-8">
          The GHG Calculator is designed for municipalities to integrate climate
          considerations into municipal decision-making processes across all
          departments. Customizing the tool enables municipal decision makers to
          accurately evaluate the greenhouse gas impacts of policies and
          projects in their locale, ensuring climate considerations can be
          incorporated into every municipal decision.
        </p>
        <p class="mb-8">
          This free version of the tool includes energy and emissions data from
          Calgary, Canmore, Durham, Fredericton, Hamilton, Mississauga, Ottawa, Saint John, Saskatoon, Vaughan, Vernon, and
          West Vancouver. SSG can customize the tool for municipalities across
          the Americas and train municipal staff to use it.
        </p>
        <h3>Initial Implementation</h3>
        <h4>Cost: $5,000</h4>
        <p class="mb-2">
          <span class="font-weight-bold">Overview:</span> The Initial
          Implementation Package includes:
        </p>
        <ul class="mb-4 ml-16">
          <li>
            Customization of the GHG calculator with local emissions factors and
            energy mix
          </li>
          <li>Two 2-hour training meetings</li>
          <li>Ten hours of support for the first year of implementation</li>
        </ul>
        <v-btn
          color="success"
          class="mb-8"
          :to="localeRoute({ name: 'contact' })"
          >Contact us to learn more</v-btn
        >
        <h3 class="mt-8">Updates</h3>
        <h4>Cost: $2,000</h4>
        <p class="mb-2">
          <span class="font-weight-bold">Overview:</span> SSG can update the
          tool at regular intervals (e.g., annually, biannually) with the latest
          emissions factors and energy mix.
        </p>
        <v-btn
          color="success"
          class="mb-8"
          :to="localeRoute({ name: 'contact' })"
          >Contact us to learn more</v-btn
        >
        <h3 class="mt-8">Training and Support</h3>
        <p class="mb-2">
          SSG can provide ongoing training and support, as well as additional
          features, such as:
        </p>
        <ul class="mb-4 ml-16">
          <li>Additional training sessions</li>
          <li>Additional support hours</li>
          <li>
            Additional capital or policy calculation modules to address specific
            needs
          </li>
          <li>Enhancements or improvements to existing calculation modules</li>
          <li>
            Customized output spreadsheets to reflect community specific needs
          </li>
          <li>Customization of the GHG calculator with client branding</li>
          <li>
            Modification of energy sources to include localized sources such as
            district energy
          </li>
        </ul>
        <v-btn
          color="success"
          class="mb-8"
          :to="localeRoute({ name: 'contact' })"
          >Contact us for a quote</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
const localeRoute = useLocaleRoute();
useSeoMeta({
  description:
    "Customization services for the GHG Calculator for Municipal Projects",
  ogTitle: "Customization - GHG Calculator for Municipal Projects",
  ogDescription:
    "Customization services for the GHG Calculator for Municipal Projects",
  ogImage: "/images/ghg_calculator_icon_250.png",
  ogUrl: "https://ghg-calculator.ssg.coop",
  twitterTitle: "Customization - GHG Calculator for Municipal Projects",
  twitterDescription:
    "Customization services for the GHG Calculator for Municipal Projects",
  twitterImage: "/images/ghg_calculator_icon_250.png",
  twitterCard: "summary",
});

useHead({
  title: "Customization",
  htmlAttrs: {
    lang: "en",
  },
});
</script>
<style lang="scss">
@use "./settings";
</style>
<style lang="scss" scoped></style>
